/* unplugin-vue-components disabled */import { render } from "./transfer-oprate.vue?vue&type=template&id=474f6ede&scoped=true&ts=true"
import script from "./transfer-oprate.vue?vue&type=script&lang=ts"
export * from "./transfer-oprate.vue?vue&type=script&lang=ts"

import "./transfer-oprate.vue?vue&type=style&index=0&id=474f6ede&scoped=true&lang=stylus"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-474f6ede"]])

export default __exports__